import PropTypes from 'prop-types';
import styled, {css} from 'styled-components';
import {grey} from './color';

export const Subtitle = styled.span`
    font-family: 'Roboto', sans-serif;
    font-size: 14px;
    color: ${({sub}) => sub ? grey.grey400 : grey.grey000};
    ${props => props.bold ? css`
      font-weight: bold;
    ` : ''}
`;
Subtitle.displayName = 'Subtitle';
Subtitle.propTypes = {
    sub: PropTypes.bool,
    bold: PropTypes.bool
};

export const SubtitleLarge = styled(Subtitle)`
    font-size: 16px;
`;
Subtitle.displayName = 'SubtitleLarge';
Subtitle.propTypes = {
    sub: PropTypes.bool,
    bold: PropTypes.bool
};
